import React from 'react'
import notfound from "../../assets/images/Notfound.gif";
import "./NotFound.scss";
const NotFound = () => {
  return (
  <>  
  <img src={notfound} alt="Not_Found" /> 

</>

  )
}

export default NotFound;
